<template>
	<div id="app">
		<Header></Header>
		<div class='body'>
			<router-view />
		</div>
		<el-backtop></el-backtop>
		<Footer></Footer>
	</div>
</template>
<script>
	export default {
		name: "app",
		data() {
			return {
				show: ''
			}
		},
		mounted() {
			this.getisMobile()
		
		},
		methods:{
			getisMobile(){
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				this.$store.dispatch("getIsMobile", Array.isArray(flag));
			}
		}
	}
</script>
<style lang="less">
	html {
		padding: 0;
		margin: 0;
		height: 100%;
		-webkit-text-size-adjust: 100%;
		-ms-text-size-adjust: 100%;
		-webkit-font-smoothing: antialiased !important;
		-webkit-tap-highlight-color: transparent;
	}

	body {
		padding: 0;
		margin: 0;
		background-color: #F5F5F5;
		height: 100%;
		min-width: 1440px;
		// height: auto !important;
		// overflow-x: hidden;
		overflow: scroll;
	}

	.body {
		// width:1200px;
		min-height: 100%;
		margin: 0 auto;

		// margin-top:62px;
	}
</style>
